import styled from "styled-components";

const StyleWrapper = styled.div`

min-height: 90vh;
display: flex;
flex-direction: column;
justify-content: space-between;
align-items: center;

  .lang-menu{
    right: 0;
    left: auto;
  }

  .header{
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 1.5rem;
    gap: 24px;
  }
  .card_wrapper{
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    .card{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 80px;      
      width: 80%;
      min-height: 50vh;
      /* White */
      background: #FFFFFF;
      box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
      border-radius: 20px;
      /* Inside auto layout */
      flex: none;
      order: 0;
      flex-grow: 0;

      .card_content{
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 40px;
        isolation: isolate;
      }
      .lead_text{
        h1{
          font-style: normal;
          font-weight: 800;
          font-size: 34px;
          line-height: 120%;
          letter-spacing: -0.02em;
          color: #1A1C1F;
          margin-bottom: 1.5rem;
        }
        h4{
          font-style: normal;
          font-size: 18px;
          color: #455560;
          margin-bottom: 2.5rem;
          strong{
            font-weight: 800;
          }
        }
        p{
          font-weight: 400;
          font-size: 12px;
          line-height: 140%;
          color: #818B9B;
          margin-bottom: 1rem;
        }
      }
    }
  }

  .act-btn{
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background: #6B47F5;
    border: none;
    width: 100%;
  }

  
  .footer{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0.75rem 1rem 1rem;
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
    flex: none;
    order: 2;
    flex-grow: 0;
    z-index: 0;
    border-radius: 0.75rem 0.75rem 0rem 0rem;
  }

  @media only screen and (max-width: 768px) {
    .container{
      background: #F2F3F5;
      text-align: center;
    }
    .card_wrapper{
      .card{
        background: #F2F3F5;
        border: none;
        width: 100%;
        padding: 1rem 1.5rem ;
        box-shadow: none;
      }
    }
    .card_content{
      flex-direction: column;
    }
    .footer{
      font-size: 12px;
    }
  }

  &.ar{
    .lang-menu{
      right: auto;
      left: 0;
    }  
  }
`;

export default StyleWrapper;
